// src/modules/operaciones/inventarios/utils/menuComun.js
//
// Definición de las tarjetas del menú "Inventario y Stock".

export const subModulos = [
  { id: 'ajustes', titulo: 'Ajustes', desc: 'Consulta y ajuste de inventario.', icon: '⚙️', activo: true },
  { id: 'negativos', titulo: 'Negativos', desc: 'Gestión de inventarios negativos.', icon: '📉', activo: true }, // <-- Cambiado a true
  { id: 'traslados', titulo: 'Traslados', desc: 'Movimientos entre bodegas.', icon: '🚚', activo: true },
  { id: 'precios', titulo: 'Ajustar Precio', desc: 'Actualización masiva de precios.', icon: '💲', activo: true },
  { id: 'conversiones', titulo: 'Conversiones', desc: 'Conversión de unidades de medida.', icon: '🔄', activo: false },
  { id: 'informes', titulo: 'Informes', desc: 'Reportes y estadísticas de inventario.', icon: '📊', activo: true },
];